import styled from 'styled-components';

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: row-reverse;
  align-items: flex-start;
  gap: var(--gap);
`;

export const ImageWrapper = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  width: 95px;
  height: 110px;
  padding: 20px;
  background: var(--background);
  border-radius: 8px;

  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
`;

export const ContentWrapper = styled.div`
  flex-grow: 1;
`;

export const Name = styled.h3`
  display: inline-block;
  margin-bottom: 8px;
`;

export const Description = styled.p`
  margin: 4px 0;
  color: var(--text-light);
  white-space: pre-wrap;
`;

export const ProductLabels = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
`;

export const LikeWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: var(--gap);
  margin: 16px 0 0;
  padding: 16px 0 0;
  border-top: 2px solid var(--background);
`;
